import { render, staticRenderFns } from "./CheckboxPhone.vue?vue&type=template&id=677bc9d4&"
import script from "./CheckboxPhone.vue?vue&type=script&lang=ts&"
export * from "./CheckboxPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports